import ScheduleSlotModel from "./ScheduleSlotModel";
import { ApiResponse } from "../apiResponse";
export default class FormattedScheduleResponseModel {
  schedule: { [dayOfTheWeek: string]: ScheduleSlotModel };
  constructor(arg: any) {
    this.schedule = {};
    Object.keys(arg).forEach((dayOfTheWeekName) => {
      this.schedule[dayOfTheWeekName] = arg[dayOfTheWeekName].map(
        (slotData: any) => {
          return ScheduleSlotModel.fromApiResponse(slotData);
        }
      );
    });
  }

  static fromApiResponse(response: ApiResponse) {
    return new FormattedScheduleResponseModel(response.data);
  }
}
